import { Injectable } from '@angular/core';
import { filter, map } from 'rxjs/operators';
import { StateService } from '@rci/state-service';
import { getLatestValue } from '@rogers/self-serve-utils';

@Injectable({ providedIn: 'root' })
export class LoginStateFacade {
  isLoggedIn$ = this.getLoginState$().pipe(map(loginState => loginState.isUserAuthenticated));

  constructor(private readonly stateService: StateService) {}

  get userName() {
    return getLatestValue(this.getLoginState$().pipe(map(loginState => loginState.userName)));
  }

  getLoginState$() {
    return this.stateService.loginState$.pipe(filter(loginState => !!loginState));
  }
}
